import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cx } from 'emotion';
import * as React from 'react';

import { switchRootClass, switchThumbClass } from './style.css';

const Toggle = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cx(className, switchRootClass)}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={switchThumbClass}
    />
  </SwitchPrimitives.Root>
));

Toggle.displayName = SwitchPrimitives.Root.displayName;

export { Toggle };
